import { render } from "./airHumidity.vue?vue&type=template&id=85d2187e&ts=true"
import script from "./airHumidity.vue?vue&type=script&lang=ts"
export * from "./airHumidity.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__